<template>
<main-content>
    <div class="bg-white p-3 rounded shadow-sm">
        <create-form :on_submit="create" :form_data="form_data" :form_meta_data="form_meta_data"></create-form>
    </div>
</main-content>
</template>

<script>
import $ from 'jquery';
import mainContent from '@/components/main-content.vue';
import CreateForm from './components/wallet-type-form';
import { i18n } from '@/plugins/i18n';
import { stakeholdersService } from '@/common/api.service';
import IranSheba from 'iran-sheba';

export default {
    components: {
        mainContent,
        CreateForm,
    },
    data() {
        return {
            form_data: {
                cellphone_number:           '',
                first_name_fa:              '',
                last_name_fa:               '',
                sheba_numbers:              [],
                is_editable:                true,
            },
            form_meta_data: {
                submit_btn_progress: false,
                submit_btn_text: i18n.t('stakeholders.btn.add_wallet_type_stakeholder'),
                invalid_sheba_numbers: [],
            }
        };
    },
    methods: {
        create() {
            let form = $('#submit_form');

            form.validate({
                rules: {
                    sheba_number_1: {
                        required: true,
                    },
                    cellphone_number: {
                        required: true,
                    },
                    first_name_fa: {
                        required: true,
                    },
                    last_name_fa: {
                        required: true,
                    },
                }
            });

            this.form_meta_data.invalid_sheba_numbers = [];
            let valid_sheba_numbers = [];

            for (let i = 0; i < this.form_data.sheba_numbers.length; ++i) {
                let value = this.form_data.sheba_numbers[i];

                // filter empty sheba
                if (value == '') {
                    continue;
                }
                valid_sheba_numbers.push(value);

                let sheba = 'IR' + value.split('-').join('');

                if (!IranSheba.isValid(sheba)) {
                    this.form_meta_data.invalid_sheba_numbers.push(i);
                }
            }

            if (this.form_meta_data.invalid_sheba_numbers.length) {
                return;
            }

            if (!form.valid()) {
                return;
            }
            
            this.form_meta_data.submit_btn_progress = true;

            let params = {
                sheba_numbers:              valid_sheba_numbers,
                cellphone_number:           this.form_data.cellphone_number,
                first_name_fa:              this.form_data.first_name_fa,
                last_name_fa:               this.form_data.last_name_fa,
            };

            stakeholdersService.create_wallet_type(params).then((response) => {
                this.$router.push('/stakeholders');
            })
            .catch(({response}) => {
                if(response.data) {
                    form.validate().showErrors(response.data.data);
                }
                this.showMsg(form, 'danger', response.data.message);
                window.scrollTo({top: 0, behavior: 'smooth'});
            })
            .finally(() => {
                this.form_meta_data.submit_btn_progress = false;
            });
        },
    }
}
</script>
